import React, { HTMLAttributes } from "react";
import { useCombinedThemeMode } from "../../../../util/theme/useCombinedThemeMode";
import { selectBasicFontTheme } from "../selectV2Theme";
import { SelectPlaceholderStyled } from "./SelectPlaceholderStyled";

interface SelectPlaceholderProps extends HTMLAttributes<HTMLDivElement> {
    hasContentBefore: boolean;
}

export const SelectPlaceholder = ({ children, hasContentBefore, ...rest }: SelectPlaceholderProps) => {
    const themeMode = useCombinedThemeMode();
    return (
        <SelectPlaceholderStyled
            themeMode={themeMode}
            {...selectBasicFontTheme.variant[themeMode]}
            lineClamp={1}
            aria-hidden={true}
            hasContentBefore={hasContentBefore}
            {...rest}
        >
            {children}
        </SelectPlaceholderStyled>
    );
};
